var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskView({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 39C34.6569 39 36 37.6569 36 36C36 34.3431 34.6569 33 33 33C31.3431 33 30 34.3431 30 36C30 37.6569 31.3431 39 33 39Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6655 35.2185C43.7387 32.8573 42.1393 30.82 40.0657 29.3591C37.9921 27.8982 35.5354 27.078 33 27C30.4646 27.078 28.0079 27.8982 25.9343 29.3591C23.8607 30.82 22.2613 32.8573 21.3345 35.2185L21 36L21.3345 36.783C22.2615 39.1439 23.861 41.1809 25.9346 42.6415C28.0082 44.1021 30.4648 44.9221 33 45C35.5352 44.9221 37.9918 44.1021 40.0654 42.6415C42.139 41.1809 43.7385 39.1439 44.6655 36.783L45 36L44.6655 35.2185ZM33 42C31.8133 42 30.6533 41.6481 29.6666 40.9888C28.6799 40.3295 27.9108 39.3925 27.4567 38.2961C27.0026 37.1997 26.8838 35.9933 27.1153 34.8295C27.3468 33.6656 27.9182 32.5965 28.7574 31.7574C29.5965 30.9182 30.6656 30.3468 31.8295 30.1153C32.9933 29.8838 34.1997 30.0026 35.2961 30.4567C36.3925 30.9108 37.3295 31.6799 37.9888 32.6666C38.6481 33.6533 39 34.8133 39 36C38.998 37.5907 38.3652 39.1157 37.2404 40.2404C36.1157 41.3652 34.5907 41.998 33 42Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.428571
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 42H10.5V10.5H15V15H33V10.5H37.5V24H40.5V10.5C40.5 9.70435 40.1839 8.94129 39.6213 8.37868C39.0587 7.81607 38.2956 7.5 37.5 7.5H33V6C33 5.20435 32.6839 4.44129 32.1213 3.87868C31.5587 3.31607 30.7956 3 30 3H18C17.2044 3 16.4413 3.31607 15.8787 3.87868C15.3161 4.44129 15 5.20435 15 6V7.5H10.5C9.70435 7.5 8.94129 7.81607 8.37868 8.37868C7.81607 8.94129 7.5 9.70435 7.5 10.5V42C7.5 42.7957 7.81607 43.5587 8.37868 44.1213C8.94129 44.6839 9.70435 45 10.5 45H18V42ZM18 6H30V12H18V6Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.428571
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskView);
export default __webpack_public_path__ + "static/media/task-view.be2cd3456b73bd4cbae1003876cd002c.svg";
export { ForwardRef as ReactComponent };